export const mediaQueries = {
  extraSmall: '(min-width: 0px)',
  small: '(min-width: 576px)',
  medium: '(min-width: 768px)',
  large: '(min-width: 992px)',
  extraLarge: '(min-width: 1200px)',
}

// This doesn't use Object.keys(mediaQueries) because the order is very important!
export const mediaQueriesList = ['extraSmall', 'small', 'medium', 'large', 'extraLarge']

export const ie11media = '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)'
